// Domain module extracted from lib/api.ts (frontend containment F1).
// Moved verbatim: endpoint paths, methods, payloads, parsing, types and export names
// are unchanged. Import via lib/api.ts, which re-exports this module.
import { request } from './client';

// ─── Meta (Dealton-only YC outreach campaign) ──────────────────────────

export interface MetaSenderHealth {
  email: string;
  status: 'ok' | 'missing' | 'expired' | 'failed';
  detail: string;
}
export interface MetaHealth {
  senders: MetaSenderHealth[];
  ready: boolean;
}
export const getMetaHealth = () => request<MetaHealth>('/prospecting/meta/health');

export interface MetaTemplate {
  id: string;
  label: string;
  subject: string;
  body: string;
  is_default: number;
}
export const listMetaTemplates = () =>
  request<{ templates: MetaTemplate[] }>('/prospecting/meta/templates');
export const upsertMetaTemplate = (t: { id: string; label: string; subject: string; body: string; is_default?: boolean }) =>
  request<{ template: MetaTemplate }>('/prospecting/meta/templates', {
    method: 'PUT', body: JSON.stringify(t),
  });
export const deleteMetaTemplate = (id: string) =>
  request<{ deleted: boolean }>(`/prospecting/meta/templates/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });

export interface MetaRecipientInput {
  email: string;
  company?: string;
  first_name?: string;
}
export interface MetaCommitResult {
  job_id: string;
  runner_pid: number;
  total: number;
}
export const commitMetaJob = (data: {
  template_id: string;
  recipients: MetaRecipientInput[];
  initial_offset_minutes?: number;
  delay_2_days?: number;
  delay_3_days?: number;
  email_1_sender?: 'partner@dealton.ai' | 'marcus@dealton.ai';
  cancel_on_signup?: boolean;
  dispatch_stagger_seconds?: number;
}) =>
  request<MetaCommitResult>('/prospecting/meta/commit', {
    method: 'POST', body: JSON.stringify(data),
  });

export interface MetaJob {
  id: string;
  company: string;
  user_email: string;
  status: 'preview' | 'queued' | 'running' | 'completed' | 'cancelled' | 'failed';
  template_id: string;
  total: number;
  completed: number;
  failed: number;
  replied: number;
  created_at: string;
  finished_at?: string;
}
export interface MetaTarget {
  id: string;
  job_id: string;
  recipient_email: string;
  recipient_company?: string;
  recipient_first_name?: string;
  status: 'pending' | 'generating' | 'sent' | 'failed' | 'replied';
  error_text?: string;
  marcus_message_id?: string;
  sara_message_id?: string;
  daniel_message_id?: string;
}
export const getMetaJob = (jobId: string) =>
  request<{ job: MetaJob; targets: MetaTarget[] }>(`/prospecting/meta/${encodeURIComponent(jobId)}`);
export const listMetaJobs = () => request<MetaJob[]>('/prospecting/meta');
export const cancelMetaJob = (jobId: string) =>
  request<{ deleted?: boolean; cancelled?: boolean }>(`/prospecting/meta/${encodeURIComponent(jobId)}`, {
    method: 'DELETE',
  });
